// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginSubmitFieldWithBack_root__CvRCZ","forgotPassword":"LoginSubmitFieldWithBack_forgotPassword__S41JR","submitButton":"LoginSubmitFieldWithBack_submitButton__Uu3dd"};